<template>
  <v-menu :nudge-width="220" offset-y :nudge-left="150">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Container operations</v-btn>
      <v-btn small icon v-on="on" v-on:click.prevent v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
    </template>
    <v-list dense>
      <v-list-item :to="{name:'InventoryBulkContainersTransactions',params:{bulkContainerId:bulkContainer.id}}"><v-list-item-title>Transactions</v-list-item-title></v-list-item>
      <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Bulk containers',to:{name:'InventoryBulkContainers'}}]},query:{to:'reports/inventory/ReportsLot',id:bulkContainer.id,lot:bulkContainer.contents.lot,forward:1}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
      <v-list-item v-if="company.allowAudit && company.permissions.includes('audit')" :to="{name:'Audit',query:{entityId:bulkContainer.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
      <template v-if="!readOnly">
        <v-divider/>
        <v-menu :nudge-left="260">
          <template v-slot:activator="{on:reduce}">
            <v-list-item v-on="reduce">
              <v-list-item-title>Reduce/move inventory</v-list-item-title>
              <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
            </v-list-item>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'ExciseVesselTransferToTank',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Move contents to a tank</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ExciseVesselTransferToBulkContainer',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Move contents to another bulk container</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item v-if="sites.length>1" :to="{name:'ExciseVesselTransferSite',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Move to site</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ExciseVesselTransferToUserLicense',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Transfer to user license</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ExciseVesselTransferToSpiritsLicense',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Transfer to spirits license</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ExciseVesselTransferToWineLicense',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Transfer to wine license</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item :to="{name:'ExciseVesselReduceInventory',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Reduce inventory</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ExciseVesselAdjustInventory',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Adjust inventory</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ExciseVesselReassignLot',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Reassign lot</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ExciseVesselFortifyWine',params:{vesselId:bulkContainer.id}}"><v-list-item-title>Fortify wine</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
        <v-divider/>
        <generate-qr-code type="BulkContainer" :id="bulkContainer.id"/>
        <v-list-item :to="{name:'InventoryBulkContainersEdit',params:{bulkContainerId:bulkContainer.id}}"><v-list-item-title>Edit bulk container</v-list-item-title></v-list-item>
        <v-list-item @click="$emit('delete')"><v-list-item-title>Delete bulk container</v-list-item-title></v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import generateQrCode from '@/components/GenerateQrCode'

export default {
  name: 'InventoryBulkContainerMenu',
  components: {generateQrCode},
  props: {
    bulkContainer: {type:Object, required:true},
    readOnly: {type:Boolean, required:false, default:false}
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true, {B263:true,B265:true,B266:true});
    },
    company() {
      return this.$store.getters.company;
    }
  }
}
</script>